// `_isNull` : an object's function
// ---------------------------------

// Is a given value equal to null?
export default function (obj) {
	return obj === null;
};